import { ScreenCatalogConfig } from '@sasser/sfh-agentic-ui';

export const RAIL360_SCREEN_CATALOG: ScreenCatalogConfig = {
  screens: [
    {
      viewKey: 'railcar',
      routeTemplate: '/commercial/railcar/:id',
      params: [{ name: 'id', resolvedBy: 'The numeric Rail360 railcar id: id from railcar_search or railcar details, or railcarId on other tool results. Never the railcar mark.' }],
      purpose: 'Open the complete record for one railcar. Use this when the user asks to view or open a railcar.',
      shows: ['Railcar profile, ownership and leases'],
    },
    {
      viewKey: 'customer',
      routeTemplate: '/commercial/customer/:id',
      params: [{ name: 'id', resolvedBy: 'CustomerSummary.salesForceId from customer_search, customer_by_name, or customer_by_salesforce_id. Never the integer Id.' }],
      purpose: 'Open the complete record for one customer. Use this when the user asks to view or open a customer or its details.',
      shows: ['Customer identity, contacts, agreements and account details'],
    },
    {
      viewKey: 'rail360View',
      routeTemplate: '/360view/:type/:id/:name',
      params: [
        { name: 'type', resolvedBy: 'Exactly "railcar" or "customer", lowercase.' },
        { name: 'id', resolvedBy: 'For railcar: the numeric Rail360 railcar id. For customer: CustomerSummary.salesForceId, never the integer Id.' },
        { name: 'name', resolvedBy: 'For railcar: the railcar mark with a space, such as UTLX 12345. For customer: the customer name with any "/" and "#" removed.' },
      ],
      purpose: 'Open the unified 360-degree view for a railcar or customer. Use only when the user explicitly asks for the 360 view; otherwise open the railcar or customer screen.',
      shows: ['Cross-domain summary and related operational records'],
    },
    {
      viewKey: 'lease',
      routeTemplate: '/commercial/lease/:id',
      params: [{ name: 'id', resolvedBy: 'The numeric Rail360 lease id: id from lease search results or leaseId on lease history. Never the rider name.' }],
      purpose: 'Open a lease or lease rider.',
      shows: ['Lease terms, customers, railcars and billing details'],
    },
    {
      viewKey: 'facility',
      routeTemplate: '/fleet/facility/:id',
      params: [{ name: 'id', resolvedBy: 'FacilitySummary.id from the facility tools. Never the facility code, SPLC, or name.' }],
      purpose: 'Open a fleet facility.',
      shows: ['Facility profile and operational details'],
    },
    {
      viewKey: 'programWork',
      routeTemplate: '/fleet/programwork/:id',
      params: [{ name: 'id', resolvedBy: 'The numeric program-work id: id from program work definition search or programWorkId on railcar program work. Never the program name.' }],
      purpose: 'Open a program-work record.',
      shows: ['Program scope, status, dates and assigned railcars'],
    },
    {
      viewKey: 'serviceEvent',
      routeTemplate: '/fleet/serviceevent/:id',
      params: [{ name: 'id', resolvedBy: 'The numeric service-event id: id from service event tools or serviceEventId on other tool results.' }],
      purpose: 'Open a railcar service event.',
      shows: ['Service-event details, work and status'],
    },
    {
      viewKey: 'trackAndTrace',
      routeTemplate: '/commercial/trackandtrace/search/:id',
      params: [{ name: 'id', resolvedBy: 'The numeric traceRequestId from the track-and-trace tool. Not the railcar id or mark.' }],
      purpose: 'Open the track-and-trace results for one active trace request on a railcar.',
      shows: ['Railcar location and movement history'],
    },
    {
      viewKey: 'railcarDocuments',
      routeTemplate: '/commercial/documents/search/:id',
      params: [{ name: 'id', resolvedBy: 'The railcar mark with a space, such as UTLX 12345. Not the numeric railcar id.' }],
      purpose: 'Open documents associated with a railcar.',
      shows: ['Railcar attachments and document metadata'],
    },
  ],
};
